import { render, staticRenderFns } from "./MemorizeTable.vue?vue&type=template&id=472b69d2&scoped=true&lang=pug&"
import script from "./MemorizeTable.vue?vue&type=script&lang=js&"
export * from "./MemorizeTable.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeTable.vue?vue&type=style&index=0&id=472b69d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b69d2",
  null
  
)

export default component.exports